import React from 'react';
import Lang from '../../lang'
import { Button } from '@progress/kendo-react-buttons'
import $ from 'jquery'
import TlkTable from '../tlelrik/table/tlkTable';

class RowDeatils extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            record: {},
            tlkTable:null
        }
    }
    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.setState({
            record: this.props.record,
            tlkTable:null
        },()=>this.createDetailsTable())
    }

    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            this.setState({
                record: this.props.record,
                tlkTable:null
            },()=>this.createDetailsTable())
        }
    }

    createDetailsTable=()=>{
        let tlkTable=null;
        let tableProps = {
            columnkeyMap: {
                "Atividade": "Atividade",
                "Comentário": "Comentário",
                "Data": "Data",
                "Hora": "Hora",
                "registro antigo":"Registo antigo"
            },
            groupfield: [],
            actionbuttons: {},// Redirect: "Emitir Fatura",
            notAction: true,
        }
        let row ={};
        try {
            row = JSON.parse(this.state.record['último registro']);
        } catch (error) {
        }
        this.state.record['último registro']=row;
        if(this.props.popUpFor === 'detailsPopup'){
            let columnkeyMap = tableProps.columnkeyMap;
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
            });
            console.log("this.state.tableData", this.state.tableData);
            let tlkTable = (<TlkTable
                date={new Date()}
                key={2}
                modulename={"auditDetails"}
                noDownloadButton={true}
                notAction={true}
                list={this.state.tableData}
                groupfield={tableProps.groupfield}
                actionbuttons={tableProps.actionbuttons}
                columnlist={columnlist}
                viewFor={"auditDetails"}
                collepsview={true}
                ActionPerform={(action, id) => this.ActionPerform(action, id)}
            />)
        }
        this.setState({ tlkTable });
    }



    closePopup = () => {
        $("#left-popup-center").trigger('click');
    }
    
    makesubul = (str, key) => {
        let row =null;
        try {
            if (str === null || !str) {
                return (<></>);
            }
            row = JSON.parse(str);
        } catch (error) {
        }
       
        if (!row || (row && !row.parcel)) {
            return (<></>);
        }
        row = row.parcel;
        let ul = (
            <>
                <div className="col-md-4">
                    {Lang.langCheck.langRequest(key)}
                </div>
                <div className="col-md-8">

                    {
                        Object.keys(row).map((_k, i) => (

                            <div className="row">
                                <div className="col-md-6 ">{Lang.langCheck.langRequest(_k)}</div>
                                <div className="col-md-6 ">{row[_k]}</div>
                            </div>

                        ))
                    }

                </div>
            </>
        );
        return ul;
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        //console.log(this.state.record);
        if(this.props.popUpFor === 'detailsPopup'){
            console.log(this.state.record);
            return (
                <div className="modal-dialog">
                    <div className="modal-content" >
                        <div className="modal-header">
                            <span className="modal-title">
                                Detalhe
                            </span>
                            <Button onClick={() => this.closePopup()} className="mr-2 btn-ivdp-secondary" >Fechar</Button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6"> <b>{Lang.langCheck.langRequest("Campo")}</b></div>
                                <div className="col-md-6"><b> {Lang.langCheck.langRequest("Observation")}</b></div>
                            </div>
                            {
                                this.state.record &&
                                Object.keys(this.state.record).map((key, i) => (
    
                                    <>
                                        {
                                            key === "oldRecord" || key === "newRecord" || key === "último registro" ?
                                                <div className="row">
                                                    {this.makesubul(this.state.record[key], key)}
                                                </div>
                                                :
                                                <div className="row ">
                                                    <div className="col-md-6">{Lang.langCheck.langRequest(key)}</div>
                                                    <div className="col-md-6"> {this.state.record[key]}</div>
                                                </div>
                                        }
                                    </>
    
                                ))
                            }
    
                        </div>
                    </div>
                </div>
            )
        }
        if(this.props.popUpFor === 'legalPopup'){
            return (
                <div className="modal-dialog">
                    <div className="modal-content" >
                        <div className="modal-header">
                            <span className="modal-title">
                                Detalhe
                            </span>
                            <Button onClick={() => this.closePopup()} className="mr-2 btn-ivdp-secondary" >Cancelar</Button>
                        </div>
                        <div className="modal-body">
                            <ul>
                                {
                                    Object.keys(this.state.record).map((_k,i)=>(
                                        Lang.langCheck.langRequest(_k) === 'Modulename' || Lang.langCheck.langRequest(_k) === 'Index'?
                                        ''
                                        :
                                        <li style={{listStyleType:"none"}} key={i}><strong>{Lang.langCheck.langRequest(_k)}</strong> : {this.state.record[_k]}</li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

export default RowDeatils;